var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ComputeBudgetProgram, SystemProgram, SYSVAR_INSTRUCTIONS_PUBKEY, } from "@solana/web3.js";
import { findOrCreateAta } from "../utils/findOrCreateAta.function";
import { TOKEN_2022_PROGRAM_ID, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { METAPLEX_AUTH_RULES_PROGRAM, SOLANA_SPL_ATA_PROGRAM_ID, TOKEN_METADATA_PROGRAM, VERSION, } from "../utils/const";
import { BN } from "bn.js";
import { findNftDataAndMetadataAccount, findPnftAccounts, getCoreCollection, whichStandard, } from "../utils/findNftDataAndAccounts.function";
import { TokenStandard } from "@metaplex-foundation/mpl-token-metadata";
import { getSda } from "../utils/getPda";
import { bidToscBid } from "../utils/typeSwap";
import { DESC } from "../utils/descriptions";
import { WRAPPED_SOL_MINT } from "@metaplex-foundation/js";
import { addWSol } from "../utils/wsol";
import { checkEnvOpts, getMakeArgs } from "../utils/check";
import { ix2vTx } from "../utils/vtx";
import { createAddBidIx } from "./modifyAddBid.instructions";
import { MPL_CORE_PROGRAM_ID } from "@metaplex-foundation/mpl-core";
import { calculateMakerFee, makerFee } from "../utils/fees";
export function createMakeSwapInstructions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var cEnvOpts, makeArgs, program, connection, bids, endDate, maker, nftMintMaker, paymentMint, swapDataAccount, instructions, _a, swapDataAccountTokenAta, st, _b, makerTokenAta, mt, oneBid, leftBids, maxAmount, tokenStd, coreCollection, initIx, _c, swapDataAccountNftAta, sn, _d, makerNftAta, mn, nftMasterEditionMaker, ownerTokenRecordMaker, destinationTokenRecordMaker, authRulesMaker, _e, nftMetadataMaker, tokenStandard, initIx, initIx, addBidIxs, bidDataIxs, bTxs, _f, _g, error_1;
        var _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    console.log(VERSION);
                    return [4 /*yield*/, checkEnvOpts(Data)];
                case 1:
                    cEnvOpts = _l.sent();
                    makeArgs = getMakeArgs(Data);
                    program = cEnvOpts.program, connection = cEnvOpts.connection;
                    bids = makeArgs.bids, endDate = makeArgs.endDate, maker = makeArgs.maker, nftMintMaker = makeArgs.nftMintMaker, paymentMint = makeArgs.paymentMint;
                    swapDataAccount = getSda(maker, nftMintMaker, program.programId.toString());
                    console.log("swapDataAccount", swapDataAccount);
                    instructions = [
                        ComputeBudgetProgram.setComputeUnitLimit({
                            units: 800000,
                        }),
                    ];
                    _l.label = 2;
                case 2:
                    _l.trys.push([2, 23, , 24]);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: swapDataAccount,
                            signer: maker,
                        })];
                case 3:
                    _a = _l.sent(), swapDataAccountTokenAta = _a.mintAta, st = _a.instruction;
                    if (st)
                        instructions.push(st);
                    else
                        console.log("swapDataAccountTokenAta", swapDataAccountTokenAta);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: paymentMint,
                            owner: maker,
                            signer: maker,
                        })];
                case 4:
                    _b = _l.sent(), makerTokenAta = _b.mintAta, mt = _b.instruction;
                    if (mt)
                        instructions.push(mt);
                    else
                        console.log("makerTokenAta", makerTokenAta);
                    bids = bids.sort(function (bidA, bidB) {
                        var amountA = makerFee({ bid: bidA });
                        var amountB = makerFee({ bid: bidB });
                        return amountB - amountA;
                    });
                    console.log("bids", bids);
                    oneBid = bids[0];
                    leftBids = bids.slice(1).length > 0 ? bids.slice(1) : [];
                    // if wSOL
                    if (paymentMint === WRAPPED_SOL_MINT.toString()) {
                        maxAmount = calculateMakerFee({ bids: bids });
                        console.log("maxAmount", maxAmount);
                        if (maxAmount)
                            instructions.push.apply(instructions, addWSol(maker, makerTokenAta, maxAmount));
                    }
                    return [4 /*yield*/, whichStandard({ mint: nftMintMaker, connection: connection })];
                case 5:
                    tokenStd = _l.sent();
                    console.log("Token standard", tokenStd);
                    if (!(tokenStd === "core")) return [3 /*break*/, 8];
                    return [4 /*yield*/, getCoreCollection({ mint: nftMintMaker, connection: connection })];
                case 6:
                    coreCollection = _l.sent();
                    return [4 /*yield*/, program.methods
                            .makeSwapCore(bidToscBid(oneBid), new BN(endDate))
                            .accountsStrict({
                            collection: coreCollection,
                            maker: maker,
                            makerTokenAta: makerTokenAta,
                            nftMintMaker: nftMintMaker,
                            paymentMint: paymentMint,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            tokenProgram: TOKEN_PROGRAM_ID.toString(),
                            coreProgram: MPL_CORE_PROGRAM_ID.toString(),
                            swapDataAccount: swapDataAccount,
                            systemProgram: SystemProgram.programId.toString(),
                        })
                            .instruction()];
                case 7:
                    initIx = _l.sent();
                    instructions.push(initIx);
                    return [3 /*break*/, 17];
                case 8: return [4 /*yield*/, findOrCreateAta({
                        connection: connection,
                        mint: nftMintMaker,
                        owner: swapDataAccount,
                        signer: maker,
                    })];
                case 9:
                    _c = _l.sent(), swapDataAccountNftAta = _c.mintAta, sn = _c.instruction;
                    if (sn)
                        instructions.push(sn);
                    else
                        console.log("swapDataAccountNftAta", swapDataAccountNftAta);
                    return [4 /*yield*/, findOrCreateAta({
                            connection: connection,
                            mint: nftMintMaker,
                            owner: maker,
                            signer: maker,
                        })];
                case 10:
                    _d = _l.sent(), makerNftAta = _d.mintAta, mn = _d.instruction;
                    if (mn)
                        instructions.push(mn);
                    else
                        console.log("makerNftAta", makerNftAta);
                    if (!(tokenStd === "native")) return [3 /*break*/, 15];
                    nftMasterEditionMaker = null;
                    ownerTokenRecordMaker = null;
                    destinationTokenRecordMaker = null;
                    authRulesMaker = null;
                    return [4 /*yield*/, findNftDataAndMetadataAccount({
                            connection: program.provider.connection,
                            mint: nftMintMaker,
                        })];
                case 11:
                    _e = _l.sent(), nftMetadataMaker = _e.metadataAddress, tokenStandard = _e.tokenStandard;
                    if (!(tokenStandard == TokenStandard.ProgrammableNonFungible)) return [3 /*break*/, 13];
                    return [4 /*yield*/, findPnftAccounts({
                            connection: connection,
                            destinationAta: swapDataAccountNftAta,
                            mint: nftMintMaker,
                            ownerAta: makerNftAta,
                        })];
                case 12:
                    (_h = _l.sent(), authRulesMaker = _h.authRules, destinationTokenRecordMaker = _h.destinationTokenRecord, nftMasterEditionMaker = _h.masterEdition, ownerTokenRecordMaker = _h.ownerTokenRecord);
                    _l.label = 13;
                case 13: return [4 /*yield*/, program.methods
                        .makeSwap(bidToscBid(oneBid), new BN(endDate))
                        .accountsStrict({
                        swapDataAccount: swapDataAccount,
                        swapDataAccountNftAta: swapDataAccountNftAta,
                        swapDataAccountTokenAta: swapDataAccountTokenAta,
                        maker: maker,
                        makerNftAta: makerNftAta,
                        makerTokenAta: makerTokenAta,
                        nftMintMaker: nftMintMaker,
                        paymentMint: paymentMint,
                        nftMetadataMaker: nftMetadataMaker,
                        nftMasterEditionMaker: nftMasterEditionMaker,
                        ownerTokenRecordMaker: ownerTokenRecordMaker,
                        destinationTokenRecordMaker: destinationTokenRecordMaker,
                        authRulesMaker: authRulesMaker,
                        systemProgram: SystemProgram.programId,
                        metadataProgram: TOKEN_METADATA_PROGRAM,
                        sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                        tokenProgram: TOKEN_PROGRAM_ID,
                        ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        authRulesProgram: METAPLEX_AUTH_RULES_PROGRAM,
                    })
                        .instruction()];
                case 14:
                    initIx = _l.sent();
                    instructions.push(initIx);
                    return [3 /*break*/, 17];
                case 15:
                    if (!(tokenStd === "hybrid")) return [3 /*break*/, 17];
                    return [4 /*yield*/, program.methods
                            .makeSwap22(bidToscBid(oneBid), new BN(endDate))
                            .accountsStrict({
                            swapDataAccount: swapDataAccount,
                            swapDataAccountNftAta: swapDataAccountNftAta,
                            swapDataAccountTokenAta: swapDataAccountTokenAta,
                            maker: maker,
                            makerNftAta: makerNftAta,
                            makerTokenAta: makerTokenAta,
                            nftMintMaker: nftMintMaker,
                            paymentMint: paymentMint,
                            systemProgram: SystemProgram.programId,
                            sysvarInstructions: SYSVAR_INSTRUCTIONS_PUBKEY,
                            tokenProgram: TOKEN_PROGRAM_ID,
                            tokenProgram22: TOKEN_2022_PROGRAM_ID,
                            ataProgram: SOLANA_SPL_ATA_PROGRAM_ID,
                        })
                            .instruction()];
                case 16:
                    initIx = _l.sent();
                    instructions.push(initIx);
                    _l.label = 17;
                case 17:
                    addBidIxs = [];
                    if (!(leftBids.length > 0)) return [3 /*break*/, 19];
                    return [4 /*yield*/, createAddBidIx(__assign({ swapDataAccount: swapDataAccount, bids: leftBids, maker: maker, paymentMint: paymentMint, makerTokenAta: makerTokenAta, swapDataAccountTokenAta: swapDataAccountTokenAta }, cEnvOpts))];
                case 18:
                    bidDataIxs = _l.sent();
                    instructions.push.apply(instructions, bidDataIxs.ataIxs);
                    addBidIxs = bidDataIxs.bidIxs;
                    if (addBidIxs.length <= 3) {
                        instructions.push.apply(instructions, addBidIxs);
                        addBidIxs = [];
                    }
                    else {
                        instructions.push.apply(instructions, addBidIxs.slice(0, 3));
                        addBidIxs = addBidIxs.slice(3);
                    }
                    _l.label = 19;
                case 19:
                    _j = {
                        description: DESC.makeSwap,
                        details: Data,
                        priority: 0,
                        status: "pending"
                    };
                    return [4 /*yield*/, ix2vTx(instructions, cEnvOpts, maker)];
                case 20:
                    bTxs = [
                        (_j.tx = _l.sent(),
                            _j)
                    ];
                    console.log("addBidIxs", addBidIxs.length);
                    if (!(addBidIxs.length > 0)) return [3 /*break*/, 22];
                    _g = (_f = bTxs).push;
                    _k = {
                        description: DESC.addBid,
                        details: { swapDataAccount: swapDataAccount, bids: bids, maker: maker },
                        priority: 1,
                        status: "pending"
                    };
                    return [4 /*yield*/, ix2vTx(addBidIxs, cEnvOpts, maker)];
                case 21:
                    _g.apply(_f, [(_k.tx = _l.sent(),
                            _k)]);
                    _l.label = 22;
                case 22: return [2 /*return*/, {
                        bTxs: bTxs,
                        swapDataAccount: swapDataAccount.toString(),
                    }];
                case 23:
                    error_1 = _l.sent();
                    console.log("error init", error_1);
                    throw {
                        blockchain: "solana",
                        status: "error",
                        message: error_1,
                        swapDataAccount: swapDataAccount,
                    };
                case 24: return [2 /*return*/];
            }
        });
    });
}
